import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { MenuOutlined,  PlusCircleFilled , MinusCircleFilled,CloseSquareOutlined, EditOutlined, ArrowLeftOutlined} from '@ant-design/icons';
import { Button, Drawer, Form, Input, Menu, Popconfirm, Select, Switch } from 'antd';
import { menu } from './Dash';
import { addOperatorFunction, checkLogIn, getEnterpriseInfo, getOperators, getStore, messageGeneral, removeOperator } from './Functions';
import { useForm } from 'antd/es/form/Form';



function Operators() {
  const navigate = useNavigate();
  const [addOperator, setAddOperator] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [openDrawer, setOpenDrawer]   = useState(false)
  const [ operators, setOperators]    = useState([])
  const [stores, setStores]           = useState([])
  const [companies, setCompanies]           = useState([])
  const [form]                        = useForm();
  const [context, start ]             = messageGeneral();
  const [forCompany, setForCompany]   = useState(false)

  
    const [edit, setEdit] = useState(null)
    useEffect(()=>{
      if( edit == null) return;
      form.setFieldValue('name',  edit.name);
      form.setFieldValue('email', edit.email);
      form.setFieldValue('store', edit.pointOfSale.token);
    },[edit])


    async function callOperators() {
      setOperators( await getOperators() );

      let storeTemp = [];
      (await getStore()).forEach(s => {
        storeTemp.push({label: s.businessName , value: s.token })
      });
      setStores( storeTemp );

    }

    async function getComapies() {

      let companiesTemp = [];
      (await getStore(true)).forEach(s => {
        companiesTemp.push({label: s.businessName , value: s.token })
      });
      setCompanies( companiesTemp );
    }

    async function firstStart() {
      try{
        if(checkLogIn() == null ) navigate('/');
        if( getEnterpriseInfo().role == 'operator') navigate('/movements')
        await callOperators()
        await getComapies()
      }catch( err ){
        
      }
    }

    useEffect(() => {
      firstStart()
    },[])

    const Conferma = ( child, token ) => {
    
      async function remove() {
       const r = await removeOperator(token);
       if( r ){

        start('Operatore eliminato')
        callOperators()
       }
      }
    
      return (
        <Popconfirm
          title="Sei sicuro di voler eliminare?"
          onConfirm={()=> remove()}
          okText="Sì"
          cancelText="No"
        >
          { child }
        </Popconfirm>
      );
    };

useEffect(()=>{
  form.resetFields(['store'])
},[forCompany])


async function register(values) {
  try{
    const { name, email , password , store } = values;
    const add = await addOperatorFunction(name, email, password, store, edit ? edit.token : null);
    if( add.success ){
      if(edit){
        await callOperators();
        form.resetFields();
        setAddOperator(false)
        setEdit(null);
        start('Operatore modificato')
        
        return;
      }
      form.resetFields();
      start('Operatore aggiunto')
    }else{
      start(add.message.error)
    }
  }catch(err){
    console.log( err )
  }
}


  return (
    <div className="center bg-color-primary all-viewport">
      {context}
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
      </div>
      <div style={{position:'fixed', top: '10px', right:'10px'}}>
        {
          addOperator 
          ?
          < ArrowLeftOutlined onClick={() =>{ setAddOperator(false);  callOperators()}} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
          :
          < PlusCircleFilled  onClick={() => {setAddOperator(true);  callOperators();setEdit(null); form.resetFields()}} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
        }
      </div>
      <div className='table-smart' style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
       <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'20px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )
          }
        </div>
      </Drawer> 
          
       {
       addOperator
       ?   
        <Form
            form={form}
            onFinish={register}
          >
            <div className='center text-style' style={{ marginBottom:'10px'}}> {edit ? 'Modifica operatore' : 'Aggiungi operatore'} </div>
            <Form.Item
                name="name"
                rules={[{ required: true, message: 'Inserire nome e cognome' }]}
              >
                <Input className='input-style' placeholder='Nome Cognome'/>
            </Form.Item>

            <Form.Item
                name="email"
                rules={[{ required: true, message: 'Inserire email operatore' }]}
              >
                <Input className='input-style' placeholder='Email'/>
            </Form.Item>

            <Form.Item
                name="password"
                rules={[{ required: true, message: 'Inserire password operatore' }]}
              >
                <Input className='input-style' placeholder='Password'/>
            </Form.Item>
            <div style={{display:'flex', justifyContent:'space-between', margin:'10px'}}>
              Punto vendita
              <Switch value={forCompany} onChange={(value) => setForCompany(!forCompany)}/>
              Azienda
            </div>
            {
              forCompany 
              ?

              <Form.Item
                name="store"
                rules={[{ required: true, message: 'obbligatori' }]}
              >
                <Select options={companies} className='input-style' placeholder='Seleziona azienda'/>
              </Form.Item>
              :
              <Form.Item
                name="store"
                rules={[{ required: true, message: 'obbligatori' }]}
              >
                <Select options={stores} className='input-style' placeholder='Seleziona store'/>
              </Form.Item>
            }
            
            <Button
              className='input-style color-one'
              type="primary" 
              htmlType="submit">
              {edit ? 'Modifica' : 'Aggiungi' }</Button>
          </Form>
          : <div  style={{ height:'100%', width:'100%', maxWidth:'500px', backgroundColor:''}} className='center'> 
            <div style={{ height:'70%', width:'80%', backgroundColor:'' }}>
            <div className='center text-style' style={{ marginBottom:'10px'}}> Lista operatori </div>
              {operators.map((s, index) => {
                if(s.role == 'administrator') return;
                return (
                        <div className='center' style={{ padding:'10px', textAlign:'center', backgroundColor: (index %2 == 0) ? 'rgba(52, 121, 57, 0.5)' : 'rgba(52, 121, 57, 0.2)'   }}>
                              <div className='center' style={{ width:'100%', height:'40px', justifyContent:'flex-start'}} key={index}> { s.name+' ('+ s.pointOfSale.name+')' } </div>
                              { Conferma(<CloseSquareOutlined  style={{color:'red', fontSize:'25px'}} />, s.token) }
                              <div style={{width:'20px'}}/>
                              { <EditOutlined onClick={()=>{
                                setEdit(s)
                                setAddOperator(true);
                              }}  style={{color:'rgba(52, 121, 57, 1)', fontSize:'25px', }} /> }
                        </div>
                        )
              })}
            </div>

          </div>
        }

    </div>
  );
}

export default Operators;
